var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDishSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 102,
    viewBox: "0 0 138 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.405 12.5838C66.7622 27.1415 51.5286 47.918 39.9833 65.7519C33.4773 74.6965 25.406 90.0133 32.04 92.3172C40.5718 95.2801 46.6847 74.4235 53.1538 63.2601C66.4973 40.234 84.5125 25.9588 95.7399 19.7145C106.967 13.4702 136.047 -1.97396 101.405 12.5838Z",
    fill: "#E6CBAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7229 95.3612C15.8517 89.5757 21.1449 86.8933 24.234 83.6453C25.3461 82.3644 27.4079 80.3623 26.758 82.6011C25.9456 85.3996 23.5941 101.147 19.7229 95.3612Z",
    fill: "#E6CBAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.264 9.02585C104.657 5.34278 106.332 6.7252 108.313 6.95168C109.092 6.99472 110.315 7.203 108.972 7.69184C107.292 8.30288 97.8719 12.7089 101.264 9.02585Z",
    fill: "#E6CBAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3818 26.0441C59.8301 36.7107 38.7993 63.6799 30.7797 76.3045C30.5796 76.6196 30.2922 76.8521 29.9442 76.9872C29.368 77.2111 28.8089 76.6265 29.058 76.0608L30.5206 72.7404C31.4662 71.0321 36.1469 64.44 47.3049 51.7381C61.2525 35.8607 74.42 28.3322 82.3818 26.0441Z",
    fill: "#E6CBAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishSlice);
export default __webpack_public_path__ + "static/media/dishSlice.a52dd45f6b3e5ad36a9f7ef3925681a4.svg";
export { ForwardRef as ReactComponent };